import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { ImageSearchContent } from './ImageSearchContent';

// Modal wrapper around the image search. Used from the customer page and ticket panel.
export const ImageSearchDialog = ({ open, onOpenChange, customerId, customerName }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="co-scope co-settings w-[95vw] max-w-4xl max-h-[88vh] overflow-y-auto" data-testid="image-search-dialog">
      <DialogHeader>
        <DialogTitle>{customerName ? `Image Search — ${customerName}` : 'Image Search'}</DialogTitle>
      </DialogHeader>
      <ImageSearchContent customerId={customerId} customerName={customerName} onNavigate={() => onOpenChange(false)} />
    </DialogContent>
  </Dialog>
);

export default ImageSearchDialog;
